import { useQuery } from '@tanstack/react-query';
import Api from '../api/Api';
import { QUERY_KEYS } from './queryKeys';
import { PriceSummaryResult } from '../types/checkout';

export default function useGetPriceSummary() {
  return useQuery({
    queryKey: [QUERY_KEYS.cart.priceSummary],
    queryFn: async (): Promise<PriceSummaryResult> => {
      const response = await Api.price.GetPriceSummary();

      if (response.Error) {
        throw new Error(
          response.Error.ErrorMessage || 'Failed to get price summary'
        );
      }

      return response.Result || ({} as PriceSummaryResult);
    },
  });
}
